import _ from 'lodash';
import { isSuperNetwork } from 'src/components/Network/utils';
import { removeOptionalParamsFromPath } from 'src/common/utils/Navigation';
import { getReferralColumnConfig } from 'src/components/Dashboard/utils/columnConfigs/referrals';
import { REFERRALS_CLOSE_REFERRALS } from 'common/utils/FeatureFlag/utils/constants';

function buildSentReferralsColumnConfig({
  route,
  flagEnabled,
  currentGroup,
  groupId,
  statuses: propsStatuses,
  sidx,
  sord,
  onSortColumn,
  showProgramNameColumn,
  requestOrUploadConsent,
  closeReferral,
}) {
  const pendingConsentActions = _.compact([
    {
      label: 'Request Or Upload Consent',
      action: requestOrUploadConsent,
    },
    flagEnabled(REFERRALS_CLOSE_REFERRALS, 'outbound-referrals') ? {
      label: 'Close Referral',
      action: closeReferral,
    } : null,
  ]);
  const groupIsSuperNetwork = isSuperNetwork(currentGroup.networks, groupId);
  const statuses = _.filter(propsStatuses, (status) => status.value !== 'draft');
  const partialPath = removeOptionalParamsFromPath(_.get(route, 'path'));
  const columnConfig = getReferralColumnConfig(
    partialPath,
    statuses,
    pendingConsentActions,
    groupIsSuperNetwork,
    { sidx, sord },
    onSortColumn,
    showProgramNameColumn,
  );

  return {
    columnConfig,
    groupIsSuperNetwork,
    statuses,
    partialPath,
  };
}

export default buildSentReferralsColumnConfig;
